import { SetStateAction, useContext, useEffect } from "react";
import { otherConfigOptionsAttributesFeature } from "../../configSetupScreen/widget/configBottomBar";
import "./FeatureSelectionComponent.css"
import { PlaygroundConfigValueContext } from "../../../../../components/newPortal/NewPortalLayout";

type FeatureSelectionProps = {
  featureList: otherConfigOptionsAttributesFeature[];
  setSubFeature: (id: otherConfigOptionsAttributesFeature) => void;
  subFeature:otherConfigOptionsAttributesFeature|undefined
  setPreviewTrigger:React.Dispatch<SetStateAction<Record<string,number>>>
};
export default function FeatureSelectionComponent({ featureList,
  setSubFeature,subFeature,setPreviewTrigger
}: FeatureSelectionProps)
{
  const PlaygroundConfigContext = useContext(PlaygroundConfigValueContext);
  const {
    setRoute,
    route
  } = PlaygroundConfigContext ?? {
   setRoute:()=>{},
   route:""
  };
 
 useEffect(()=>{
  if(setRoute){
  setRoute(subFeature?.route??"")
  }
  setPreviewTrigger((prev)=>{Object.keys(prev).forEach((key)=>{
    if(key!==subFeature?.id) prev[key]=0
  })
return prev
} 
  )
 },[subFeature])

    return (
        <>
    <div className="featureSelectionComponentMained">
        <div className="featureSelectionComponentouter" >
            {featureList.map((feature)=>
                <button   className={
              subFeature?.id === feature.id
                ? "featureSelectionComponentSelectedbutton"
                : "featureSelectionComponentbutton"
            } onClick={()=>{setSubFeature(feature)
                }} key={feature.id}>{feature.id}</button>
            )}
        </div>
        </div> 
        </>
    )
}